if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.initMobileGalleryZoom();

        this.addEventListener('click', (event) => {
          if (!window.matchMedia('(max-width: 849px)').matches) return;

          const image = event.target.closest('.product-media-modal__content img[data-media-id]');
          if (!image || !this.contains(image)) return;

          event.stopPropagation();

          const container = this.querySelector('[role="document"]');
          const isZoomed = image.classList.toggle('tzn-mobile-zoomed');
          if (container) container.classList.toggle('tzn-mobile-modal-is-zoomed', isZoomed);

          if (!isZoomed) {
            if (container) {
              container.scrollLeft = 0;
              container.scrollTop = 0;
            }
            return;
          }

          requestAnimationFrame(() => {
            if (!container) return;
            const imageRect = image.getBoundingClientRect();
            container.scrollLeft = Math.max(0, (imageRect.width - container.clientWidth) / 2);
            container.scrollTop = Math.max(0, (imageRect.height - container.clientHeight) / 2);
          });
        });
      }

      initMobileGalleryZoom() {
        const sectionId = this.id.replace('ProductModal-', '');
        const gallery = document.querySelector(`#MediaGallery-${sectionId}`);
        if (!gallery) return;

        gallery.querySelectorAll('.product-single__gallery-item').forEach((item) => {
          const image = item.querySelector('img.image-element');
          if (!image || item.querySelector('.tzn-pdp-gallery-zoom-control')) return;

          const mediaId = item.getAttribute('data-media-id')?.replace(`${sectionId}-`, '');
          if (!mediaId) return;

          image.classList.add('tzn-pdp-gallery-zoom-trigger');
          image.addEventListener('click', (event) => {
            if (!window.matchMedia('(max-width: 849px)').matches) return;
            event.preventDefault();
            image.setAttribute('data-media-id', mediaId);
            this.show(image);
          });

          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'tzn-pdp-gallery-zoom-control';
          button.setAttribute('data-media-id', mediaId);
          button.setAttribute('aria-label', 'Bild vergrößern');
          button.innerHTML = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"><circle cx="10.5" cy="10.5" r="6.5"></circle><path d="M15.5 15.5 21 21M10.5 7.5v6M7.5 10.5h6"></path></svg>';
          button.addEventListener('click', (event) => {
            if (!window.matchMedia('(max-width: 849px)').matches) return;
            event.preventDefault();
            event.stopPropagation();
            this.show(button);
          });
          item.appendChild(button);
        });
      }

      resetMobileZoom() {
        this.querySelectorAll('.tzn-mobile-zoomed').forEach((image) => image.classList.remove('tzn-mobile-zoomed'));
        const container = this.querySelector('[role="document"]');
        if (container) {
          container.classList.remove('tzn-mobile-modal-is-zoomed');
          container.scrollLeft = 0;
          container.scrollTop = 0;
        }
      }

      hide() {
        this.resetMobileZoom();
        super.hide();
      }

      show(opener) {
        this.resetMobileZoom();
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');
        const isMobile = window.matchMedia('(max-width: 849px)').matches;

        if (isMobile) {
          activeMedia.classList.remove('tzn-mobile-zoomed');
          if (container) {
            container.classList.remove('tzn-mobile-modal-is-zoomed');
            requestAnimationFrame(() => {
              container.scrollLeft = 0;
              container.scrollTop = 0;
            });
          }
        } else {
          activeMedia.scrollIntoView();
          if (container) container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
